<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="750px"
  >
    <v-card>
      <v-card-title>
        <span v-if="item.id">Thông tin chi tiết</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row v-if="errors_exist">
            <v-col cols="12">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card color="amber lighten-4">
                <v-card-title>Agent</v-card-title>
                <v-card-text v-html="item.agent"/>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card color="amber lighten-4">
                <v-card-title>Chi tiết</v-card-title>
                <v-card-text>
                  <v-textarea
                    background-color="amber lighten-4"
                    color="orange orange-darken-4"
                    v-model="item.detail"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        dialog: false,
        errors_exist: false,
        errors: []
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        if (this.showDialog) {
          this.dialog = true;
        }
      }
    },
    methods: {
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      }
    }
  }
</script>